module.exports = __webpack_public_path__ + "img/way.de1f5727.png";